module.exports = __webpack_public_path__ + "ba5a2fb4728073262a63d157c07af511.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/04-Betsolutions-Dice.png
// module id = 1726
// module chunks = 2